const DashboardPage = (props) => {
    return <h1>DashboardPage</h1>;
};

export default DashboardPage;